/* AY-3-8912 sound chip emulation */

const QUEUE_DURATION = 70_000;

class AYWorkletNode extends AudioWorkletNode {
    constructor(context, getAudioFrame, options) {
        options ||= {};
        options.numberOfInputs = 0;
        options.numberOfOutputs = 1;
        options.outputChannelCount = [2];
        super(context, 'ay-processor', options);
        this.chipCount = options.processorOptions?.chipCount || 1;

        this.queuedDuration = 0;
        this.port.onmessage = (e) => {
            if (e.data.message === 'consumed') {
                this.queuedDuration -= e.data.duration;
            }
        };

        this.getAudioFrame = getAudioFrame;
        this.timer = null;
        this.stopped = false;
        this.topUpCommandBuffer();
    }

    addAudioFrame() {
        let frame = this.getAudioFrame();
        this.queuedDuration += frame.duration;
        this.port.postMessage({
            message: 'frame',
            duration: frame.duration,
            registerWrites: frame.registerWrites,
        });
    }

    connect(...args) {
        super.connect(...args);
        if (!this.timer) {
            this.timer = setInterval(() => this.topUpCommandBuffer(), 10);
        }
    }

    stop() {
        this.stopped = true;
        this.port.postMessage({ message: 'stop' });
    }

    topUpCommandBuffer() {
        if (this.stopped) {
            clearInterval(this.timer);
            this.timer = null;
        } else {
            while (this.queuedDuration < QUEUE_DURATION) {
                this.addAudioFrame();
            }
        }
    }
}

class SoftwareAYDriver {
    BUFFER_SIZE = 1024;
    CHANNEL_COUNT = 2;

    constructor(getAudioContext, frequency, stereoMode, chipCount) {
        this.getAudioContext = getAudioContext;
        this.frequency = frequency;
        this.stereoMode = stereoMode;
        this.chipCount = chipCount || 1;

        this.audioContext = null;
        this.audioContextIsInitialized = false;
        this.node = null;
        this.stopped = false;
    }

    getInitializedAudioContext() {
        this.audioContext ||= this.getAudioContext();
        return new Promise((resolve, reject) => {
            if (this.audioContextIsInitialized) {
                resolve(this.audioContext);
            } else {
                this.audioContext.audioWorklet
                    .addModule('ay_worklet.js')
                    .then(() => {
                        this.audioContextIsInitialized = true;
                        resolve(this.audioContext);
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            }
        });
    }

    start(getAudioFrame) {
        this.stopped = false;
        this.getInitializedAudioContext()
            .then((audioContext) => {
                if (!this.stopped) {
                    this.node = new AYWorkletNode(audioContext, getAudioFrame, {
                        processorOptions: {
                            chipCount: this.chipCount,
                            frequency: this.frequency,
                            stereoMode: this.stereoMode,
                        },
                    });
                    this.node.connect(audioContext.destination);
                }
            })
            .catch(() => {
                /* already logged in getInitializedAudioContext */
            });
    }

    stop() {
        this.stopped = true;
        if (this.node) {
            this.node.stop();
            this.node.disconnect(0);
            this.node = null;
        }
    }
}

export { SoftwareAYDriver };
